module.exports = __webpack_public_path__ + "media/icons/envelope-solid@2x-beb22733.png";